import { Box, Text, chakra } from "@chakra-ui/react";

const FormContainer = chakra(Box, {
  baseStyle: {
    width: { base: "full", md: "520px" },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "12px",
  },
});
const ResetPasswordTopHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "700",
    fontSize: { base: "24px", md: "28.42px" },
    marginTop: { base: "24px", md: "32px" },
    textAlign: "center",
  },
});

const ResetPasswordHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "24px", md: "32px" },
    marginTop: { base: "18px" },
    textAlign: "center",
  },
});
const ResetPasswordSubHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "12px", md: "16px" },
    alignItems: "flex-start",
    color: "primary.grayText",
  },
});

const ResetPasswordDescriptionHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "12px", md: "16px" },
    textAlign: "center",
    color: "primary.grayText",
  },
});

const ResetPasswordRequirements = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "12px", md: "14px" },
    display: "flex",
    direction: "column",
    alignItems: "flex-start",
    color: "gray.500",
    justifyItems: "start",
    justifyContent: "start",
  },
});

const ForgotPasswordForm = chakra("form", {
  baseStyle: {
    width: "100%",
  },
});

export {
  FormContainer,
  ResetPasswordTopHeading,
  ResetPasswordHeading,
  ResetPasswordSubHeading,
  ResetPasswordDescriptionHeading,
  ForgotPasswordForm,
  ResetPasswordRequirements,
};
